import React, { useState, useEffect, useRef } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { Drawer, Button } from 'quantux-ui';
import { blue, gray, salmon } from '../../theme';

const CamInspectorDrawer = (props) => {
  const [showLoader, setShowLoader] = useState(false);
  const [imageUrl, setImageUrl] = useState('');

  // -- Refs
  const imgRef = useRef();

  const styles = StyleSheet.create({
    drawerContainer: {
      position: 'relative',
      background: blue[900],
      color: blue[200],
      height: '100%',
      display: 'flex',
      flexFlow: 'column'
    },
    drawerHeader: {
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 8px',
      fontWeight: 'bold',
      borderBottom: '1px solid black',
      flexShrink: '0',
      background: blue[700]
    },
    drawerHeaderCloseIcon: {
      color: gray[300],
      opacity: showLoader ? '0.3' : '1',
      ':hover': {
        color: !showLoader ? salmon[500] : ''
      }
    },
    drawerContentArea: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 'calc(100vh - 80px)',
      // overflowY: 'hidden',
      overflowY: 'auto',
      color: gray[300],
      background: 'black',
      position: 'relative',
      zIndex: '1'
    },
    drawerFooter: {
      height: '42px',
      padding: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      background: gray[500],
      borderTop: `1px solid ${gray[300]}`
    },
    camErrCloseBtn: {
      color: gray[300],
      position: 'absolute',
      top: '4px',
      right: '4px',
      fontSize: '24px',
      ':hover': {
        color: salmon[500]
      }
    }
  });

  useEffect(() => {
    setImageUrl(props.newImageUrl);
  }, [props.newImageUrl]);

  const handleOnClickClose = () => {
    props.onClose();
  };

  const handleOnClickCancel = () => {
    props.onClickCancel();
  };

  const handleOnClickRetake = () => {
    props.onRetake();
  };

  const handleOnUsePhoto = () => {
    props.onClose();
  };

  const handleOnRotateImage = () => {
    if (imgRef.current) {
      window.imgRef = imgRef;
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = imgRef.current.width;
      canvas.height = imgRef.current.height;

      // Translate and rotate
      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate(90 * Math.PI / 180);

      // Draw the image
      ctx.drawImage(imgRef.current, -imgRef.current.naturalWidth / 2, -imgRef.current.naturalHeight / 2);

      // Set the rotated image back to the img element
      const rotatedImg = canvas.toDataURL();
      imgRef.current.src = rotatedImg;
      setImageUrl(rotatedImg);
      props.onRotate(rotatedImg, props.selectedDocument);
    }
  };

  return (
    <Drawer
      placement='right'
      visible
      toggleDrawer={() => console.log('Not applicable')}
      zIndex="50000"
      showMask={false}
      style={{ border: 'none' }}
      width={window.innerWidth}
    >
      <div className={css(styles.drawerContainer)}>
        {/* -------------- Drawer Header ---------------------------- */}
        <div className={css(styles.drawerHeader)}>
          <div className='fx fx__hv-center'>
            <div className='ml-2'>
              Document Name
            </div>
          </div>
          <i
            className={`fa fa-lg fa-times-circle ${css(styles.drawerHeaderCloseIcon)}`}
            onClick={handleOnClickCancel} // handleOnClickClose
          />
        </div>

        {/* -------------- Drawer Container ---------------------------- */}
        <div className={css(styles.drawerContentArea)}>
          <img
            ref={imgRef}
            src={imageUrl}
            style={{
              width: '90%',
              height: 'auto'
            }}
          />
        </div>

        {/* -------------- Drawer Footer ---------------------------- */}
        <div className={css(styles.drawerFooter)}>
          {/* Cancel Button */}
          <Button
            btnType='primary'
            isOutlineBtn
            onClick={handleOnClickCancel}
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '63px',
              height: '32px'
            }}
          >
            Cancel
          </Button>

          {/* Rotate Button - (Hidden for now) */}
          <Button
            btnType='primary'
            className='ml-3'
            isOutlineBtn
            onClick={handleOnRotateImage}
            style={{
              width: '32px',
              minWidth: '32px',
              height: '32px',
              minHeight: '32px',
              maxWidth: '32px',
              maxHeight: '32px',
              display: 'none',
              // display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <svg
              style={{ marginTop: '5px' }}
              width='24px'
              height='24px'
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                fill="#00A0FF"
                fillRule="evenodd"
                d="M11.417.038c.21-.02.413-.038.634-.038C18.34 0 23.49 4.84 24 11h-1.5c-.36-3.76-2.7-6.93-5.97-8.48L15.2 3.85 11.39.04l.026-.002ZM1.5 13c.36 3.76 2.7 6.93 5.97 8.49l1.33-1.34 3.81 3.82c-.073.003-.146.008-.218.012a7.058 7.058 0 0 1-.442.018C5.66 24 .51 19.16 0 13h1.5ZM16 14h2V8a2 2 0 0 0-2-2h-6v2h6v6ZM8 4v12h12v2h-2v2h-2v-2H8a2 2 0 0 1-2-2V8H4V6h2V4h2Z"
                clipRule="evenodd"
              />
            </svg>
          </Button>

          {/* Retake Button */}
          <Button
            btnType='primary'
            className='ml-3'
            isOutlineBtn
            onClick={handleOnClickRetake}
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '63px',
              height: '32px'
            }}
          >
            Retake
          </Button>
          {/* Use Photo Button */}
          <Button
            btnType='primary'
            className='ml-3'
            onClick={handleOnUsePhoto}
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '90px',
              minWidth: '90px',
              maxWidth: '90px',
              height: '32px',
              minHeight: '32px',
              maxHeight: '32px'
            }}
          >
            Use Photo
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

export default CamInspectorDrawer;
